import {OrganizedSettings} from '../../../PanelBank/types';
import {useSectionSettingsContextMaybe} from '../SectionSettingsContextProvider';
import {useWorkspaceSettingsContext} from '../WorkspaceSettingsContextProvider';
import {useWorkspaceInheritedSettings} from './useWorkspaceInheritedSettings';

export const useWorkspaceInheritedSettingsForPanel = (): OrganizedSettings => {
  const workspaceSettingsContext = useWorkspaceSettingsContext();

  // Don't throw errors if the component calling this hook isn't wrapped in a SectionSettingsContextProvider.
  // We just treat it as if the section settings don't exist and workspace settings will be used instead.
  // This is useful when we have a common component used at workspace level and re-used at section level.
  const sectionSettingsContext = useSectionSettingsContextMaybe();

  return useWorkspaceInheritedSettings(
    workspaceSettingsContext,
    sectionSettingsContext?.linePlot
  );
};
